import { useMutation, useQueryClient } from 'react-query';

import { projectsApi } from 'src/Services/API';
import { CreateProjectDto } from 'src/Services/API/generated/api';
import { trackEvent } from 'src/Services/Matomo';

const useCreateProject = (assetId: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: CreateProjectDto) => projectsApi.projectsControllerCreate(assetId, data),
    {
      onSuccess: (_response, data) => {
        trackEvent('Project', 'create', data.title);
        queryClient.invalidateQueries(['projects', assetId]);
        queryClient.invalidateQueries(['fetch-events']);
      },
    }
  );
};

export default useCreateProject;
